import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import type { Language } from '@ilteducation/content-ref-data-types';
import useUploadMedia from '@/comp/use-upload-media';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import DropFile from '@/components/base/DropFile.vue';
import { useRefLanguages } from '@/comp/use-ref-languages';
import { parseVtt, srtToVtt } from '@/foundations/helpers/subtitles';

type Props = {
  id: string;
  title?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'SubtitleAndNarrationsUploader',
  props: {
    id: null,
    title: null
  },
  emits: ['done'],
  setup(__props: any, { emit }) {

const props = __props as {
  id: string;
  title?: string;
}

const dropFileRef = ref<InstanceType<typeof DropFile> | null>(null);
const file = ref<File>();
const selectedLang = ref<Language>();


const { uploadInProgress, upload: uploadMedia } = useUploadMedia();

const upload = async () => {
  if (!file.value) return;
  const fileExtension = file.value.name.split('.').pop();
  const subType = fileExtension === 'm4a' ? 'narration' : 'subtitles';
  await uploadMedia(props.id, file.value, { subType, language: selectedLang.value?.languageCode });
  dropFileRef.value?.clearFiles();
  emit('done');
};

const { languages: availableLanguages } = useRefLanguages();

const updateFile = (dataFiles: File[]) => {
  file.value = dataFiles[0];
};

const errors = ref<string[]>([]);

watch(
  () => file.value,
  async (newFile) => {
    errors.value = [];

    if (!newFile) {
      return;
    }
    const type = newFile.type ? newFile.type.split('/').slice(-1)[0] : newFile.name.split('.').slice(-1)[0];
    if (!['vtt', 'srt'].includes(type)) {
      return;
    }
    const vttToValidate = type === 'vtt' ? newFile : await srtToVtt(newFile);
    const parsed = parseVtt(await vttToValidate.text());
    if (parsed.errors.length > 0) {
      errors.value.push(...parsed.errors.map((e) => `Line ${e.line}: ${e.message}`));
    }
  },
);

const uploadDisabled = computed(() => !file.value || !selectedLang.value || errors.value.length > 0);

return { __sfc: true,dropFileRef, file, selectedLang, emit, uploadInProgress, uploadMedia, props, upload, availableLanguages, updateFile, errors, uploadDisabled, DisableableButton, DropFile }
}

})